var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"navBar",attrs:{"id":"navBar"}},[_c('NavBar')],1),_c('div',{staticClass:"content"},[_c('router-view'),_c('div',{attrs:{"id":"footer"}},[_c('Footer')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }